<template>
    <tasks-project2></tasks-project2>
</template>

<script>
import TasksProject2 from "../projects/TasksProject2.vue";

export default {
  name: "Tasks2",
  components: {
    TasksProject2,
  }
}
</script>

<style scoped>

</style>